import React from 'react';
import { Menu, X } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { NAV_ITEMS, NavItemWithKey } from '../../constants/data';
import { LanguageSwitcher } from '../LanguageSwitcher';

interface NavbarProps {
  isMenuOpen: boolean;
  toggleMenu: () => void;
  closeMenu: () => void;
}

export const Navbar: React.FC<NavbarProps> = ({ isMenuOpen, toggleMenu, closeMenu }) => {
  const { t } = useTranslation();

  return (
    <nav className="bg-white sticky top-0 z-50 shadow-sm border-b border-slate-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between h-16 items-center">
          <div className="flex-shrink-0 flex items-center gap-2">
            <div className="w-8 h-8 bg-blue-600 rounded-lg flex items-center justify-center text-white font-bold">
              JA
            </div>
            <span className="font-bold text-xl tracking-tight text-slate-900">
              Aarón García
            </span>
          </div>

          {/* Desktop Menu */}
          <div className="hidden md:flex space-x-8 items-center">
            {NAV_ITEMS.map((item) => (
              item.isPrimary ? (
                <a
                  key={item.href}
                  href={item.href}
                  className="bg-blue-600 hover:bg-blue-700 text-white px-5 py-2 rounded-full font-medium transition-all shadow-lg shadow-blue-600/20"
                >
                  {t((item as NavItemWithKey).i18nKey)}
                </a>
              ) : (
                <a
                  key={item.href}
                  href={item.href}
                  className="text-slate-600 hover:text-blue-600 font-medium transition-colors"
                >
                  {t((item as NavItemWithKey).i18nKey)}
                </a>
              )
            ))}
            <LanguageSwitcher />
          </div>

          {/* Mobile Menu Button */}
          <div className="md:hidden flex items-center gap-4">
            <LanguageSwitcher />
            <button
              onClick={toggleMenu}
              className="text-slate-600 hover:text-slate-900 focus:outline-none"
              aria-label="Toggle menu"
            >
              {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Menu Dropdown */}
      {isMenuOpen && (
        <div className="md:hidden bg-white border-t border-slate-100 absolute w-full shadow-lg">
          <div className="px-4 pt-2 pb-6 space-y-2">
            {NAV_ITEMS.map((item) => (
              <a
                key={item.href}
                href={item.href}
                onClick={closeMenu}
                className={`block px-3 py-3 rounded-md text-base font-medium ${item.isPrimary
                    ? 'text-blue-600 hover:bg-blue-50'
                    : 'text-slate-700 hover:bg-slate-50'
                  }`}
              >
                {t((item as NavItemWithKey).i18nKey)}
              </a>
            ))}
          </div>
        </div>
      )}
    </nav>
  );
};
